/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suspend_Storefront_WarningInputs */

const en_suspend_storefront_warning = /** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to suspend your storefront? This will hide your site from all visitors.`)
};

const id_suspend_storefront_warning = /** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda yakin ingin menangguhkan etalase Anda? Ini akan menyembunyikan situs Anda dari semua pengunjung.`)
};

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const es_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const fr_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const de_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const ja_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const zh_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const ar_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const it_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const ru_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const pt_suspend_storefront_warning = en_suspend_storefront_warning;

/** @type {(inputs: Suspend_Storefront_WarningInputs) => LocalizedString} */
const ko_suspend_storefront_warning = en_suspend_storefront_warning;

/**
* | output |
* | --- |
* | "Are you sure you want to suspend your storefront? This will hide your site from all visitors." |
*
* @param {Suspend_Storefront_WarningInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const suspend_storefront_warning = /** @type {((inputs?: Suspend_Storefront_WarningInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suspend_Storefront_WarningInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_suspend_storefront_warning(inputs)
	if (locale === "es") return es_suspend_storefront_warning(inputs)
	if (locale === "fr") return fr_suspend_storefront_warning(inputs)
	if (locale === "de") return de_suspend_storefront_warning(inputs)
	if (locale === "ja") return ja_suspend_storefront_warning(inputs)
	if (locale === "zh") return zh_suspend_storefront_warning(inputs)
	if (locale === "ar") return ar_suspend_storefront_warning(inputs)
	if (locale === "id") return id_suspend_storefront_warning(inputs)
	if (locale === "it") return it_suspend_storefront_warning(inputs)
	if (locale === "ru") return ru_suspend_storefront_warning(inputs)
	if (locale === "pt") return pt_suspend_storefront_warning(inputs)
	return ko_suspend_storefront_warning(inputs)
});